import {
  AppContext,
  AccessControl,
  isAuthorised,
  Loader,
  getTranslatedText,
  NoDataCard,
  getConversationOrder,
  reactbellchatScrollTop,
  reactbellchatScrollBottom
} from '@nile/components';
import { ActionContainer } from '@nile/mangifera/src/Containers/ChatContainers';
import {
  ConversationBubble,
  TaskBubble
} from '@nile/projects/src/Components/Chat';
import React, { useState, useEffect, useContext, useRef } from 'react';
import styled from 'styled-components';
import { ChatFeed } from 'react-bell-chat';
import { injectIntl, FormattedMessage } from 'react-intl';
import ProjectContext from '@nile/projects/src/Contexts/ProjectContext';
import envConfig from '@nile/home/src/Config/env';
import {
  FeedWrap,
  EmptyStateHolder,
  StyledConversation
} from './ProjectFeedsContainer';

const ProjectConversationsContainer = (props) => {
  const appContext = useContext(AppContext);
  const projectContext = useContext(ProjectContext);
  const { user } = appContext;
  const [allConversations, setAllConversations] = useState(
    props.conversations || []
  );
  const { ticket, actions, conversations, intl } = props;

  useEffect(() => {
    setAllConversations(props.conversations);
  }, [props.conversations]);

  if (props.loading) {
    return (
      <div className="full-height full-width flex actr jctr">
        <Loader />
      </div>
    );
  }

  const handleCommentSubmission = (editorObject, clearState) => {
    const chat = {
      content: editorObject.message,
      mentions: editorObject.mentions,
      attachments: editorObject.attachments?.map(
        ({ fileName, originalFileName, fileSize }) => {
          return { fileName, originalFileName, fileSize };
        }
      ),
      inlineImages: editorObject.inlineImages
    };
    props.actions
      .saveProjectComment({
        variables: { projectId: props.project.projectId, input: chat },
        input: { projectId: props.project.projectId, input: chat }
      })
      .then((res) => {
        if (res?.data?.addProjectComment) {
          clearState(true);
        }
      });
  };

  const authors = [];
  const userKey = {
    note: 'addedBy',
    conversation: 'addedBy',
    task: 'technician',
    approval: 'approver'
  };
  const timeKey = {
    conversation: 'addedOn',
    note: 'addedOn',
    approval: 'sentOn'
  };
  const msgKey = {
    conversation: 'content',
    task: 'title'
  };
  const data =
    allConversations.length > 0
      ? allConversations.map((feed, idx) => {
          const currUser = feed.addedBy;
          if (
            currUser &&
            !authors.some((el) => el.authorId === currUser.userId)
          ) {
            authors.push({
              name: `${currUser.firstName} ${currUser.lastName}`,
              authorId: currUser.userId
            });
          }
          return {
            message: feed.content,
            isSend: false,
            id: feed.conversationId,
            authorId: currUser?.userId || '123',
            type: 'conversation',
            user: currUser,
            time: feed.addedOn,
            status: feed?.status,
            data: feed
          };
        })
      : [];
  return (
    <StyledConversation
      className={
        isAuthorised(projectContext.features, 'comments.add')
          ? 'full-height scroll'
          : 'no-access full-height scroll'
      }
    >
      <FeedList
        data={data}
        authors={authors}
        user={user}
        handleCommentSubmission={handleCommentSubmission}
        {...props}
      />
    </StyledConversation>
  );
};

const CustomBubble = (props) => {
  const { message } = props;
  const bubbles = {
    // note: <NoteBubble {...props}></NoteBubble>,
    conversation: <ConversationBubble {...props} />,
    task: <TaskBubble {...props} />
  };
  return <div className="bubbleContainer">{bubbles.conversation}</div>;
};

const FeedList = (props) => {
  const {
    user,
    authors,
    data: conversations,
    intl,
    handleCommentSubmission
  } = props;

  const projectContext = useContext(ProjectContext);

  const [editor, setEditor] = useState('');

  const projectConversationRef = useRef();
  // value from user preferred conversation order
  const conversationOrder = getConversationOrder() || 'ASC';

  useEffect(() => {
    if (conversations.length > 0) {
      if (conversationOrder === 'ASC') {
        reactbellchatScrollBottom(projectConversationRef);
      } else {
        reactbellchatScrollTop(projectConversationRef);
      }
    }
  }, [conversations]);

  const getEmptyState = () => {
    return (
      <NoDataCard
        imageURL={`url(${envConfig.imageRoot}svg/notes_empty_state.svg)`}
        text={<FormattedMessage id="project.details.notes.emptyState" />}
        description={
          <FormattedMessage id="project.details.notes.emptyState.description" />
        }
        type="secondary"
      />
    );
  };
  return (
    <FeedWrap className="scroll full-height">
      {conversations.length > 0 ? (
        <ChatFeed
          ref={projectConversationRef}
          customChatBubble={CustomBubble}
          messages={conversations}
          authors={authors}
          yourAuthorId={user.userId}
        />
      ) : (
        <EmptyStateHolder className="scroll flex center jcenter">
          {getEmptyState()}
        </EmptyStateHolder>
      )}
      <AccessControl
        reference={projectContext.features}
        roleToCheck="comments.add"
        render={
          <ActionContainer
            hideToolbar={false}
            template={editor}
            ReadOnly
            onMessageSubmit={handleCommentSubmission}
            module="PROJECT_COMMENT"
            details={{
              operation: 'CREATE',
              projectId: props.project.projectId
            }}
            allowMentions
            attachmentUploadUrl={`${envConfig.fileRoot}/upload`}
            uploadParams={{
              module: 'PROJECT_CONVERSATION_ATTACHMENT',
              details: JSON.stringify({ projectId: props.project.projectId })
            }}
            placeholder={getTranslatedText(
              intl,
              'project.details.conversation.placeholder'
            )}
          />
        }
      />
    </FeedWrap>
  );
};

export default injectIntl(ProjectConversationsContainer);
